(() => {
  const states = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(input) {
    if (states.has(input)) return;
    const prompts = input.dataset.d2fSearchPrompts.split('|').filter(Boolean);
    if (!prompts.length) return;
    function randomIndex(previous = -1) {
      if (prompts.length < 2) return 0;
      const choice = Math.floor(Math.random() * (prompts.length - (previous < 0 ? 0 : 1)));
      return previous >= 0 && choice >= previous ? choice + 1 : choice;
    }
    const state = { index: randomIndex(), length: 0, deleting: false, composing: false };
    states.set(input, state);
    input.classList.add('d2f-native-search-prompt');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    function fit() {
      if (!context || !input.clientWidth) return;
      const style = getComputedStyle(input);
      const available = input.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) - 8;
      context.font = style.fontWeight + ' 16px ' + style.fontFamily;
      const widest = Math.max(...prompts.map(message => context.measureText(message).width));
      const size = Math.min(16, Math.floor(available / widest * 160) / 10);
      input.style.setProperty('--d2f-search-prompt-size', Math.max(8, size) + 'px');
    }
    const observer = new ResizeObserver(fit);
    observer.observe(input);
    document.fonts?.ready.then(fit);
    input.addEventListener('input', fit);
    input.addEventListener('compositionstart', () => { state.composing = true; });
    input.addEventListener('compositionend', () => { state.composing = false; fit(); });
    input.form?.addEventListener('reset', () => window.setTimeout(fit, 0));
    function tick() {
      if (document.hidden || input.value || state.composing || !input.getClientRects().length) {
        window.setTimeout(tick, 250);
        return;
      }
      if (reducedMotion.matches) {
        input.placeholder = prompts[state.index];
        window.setTimeout(tick, 1000);
        return;
      }
      const message = Array.from(prompts[state.index]);
      state.length += state.deleting ? -1 : 1;
      input.placeholder = message.slice(0, state.length).join('') || ' ';
      let delay = state.deleting ? 35 : 65;
      if (!state.deleting && state.length >= message.length) {
        state.deleting = true;
        delay = 3000;
      } else if (state.deleting && state.length <= 0) {
        state.deleting = false;
        state.index = randomIndex(state.index);
        delay = 250;
      }
      window.setTimeout(tick, delay);
    }
    fit();
    tick();
  }
  function init() {
    document.querySelectorAll('input[data-d2f-search-prompts]').forEach(setup);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();